import { useNavigate } from "react-router-dom";
import { LOGO } from "../data/site";
import { goSection } from "./Navbar";

const LINKS = [
  { label: "Ecosystem", hash: "#ecosystem" },
  { label: "How We Work", hash: "#process" },
  { label: "Why SMIPL", hash: "#why" },
  { label: "Industries", hash: "#industries" },
  { label: "Customers", hash: "#customers" },
  { label: "Partners", hash: "#partners" },
];

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer data-testid="site-footer" className="border-t border-white/8 py-14">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <img src={LOGO} alt="SMIPL" className="h-10 w-auto rounded-md" />
          <p className="mt-4 text-sm text-slate-500">Swapna Meditech Industries Pvt. Ltd.</p>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-smipl-orange mt-1.5">Your Trusted Service Partner</p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => goSection(navigate, l.hash)}
              className="text-sm text-slate-400 hover:text-smipl-orange transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
          <a href="/contact" data-testid="footer-link-contact" className="text-sm text-slate-400 hover:text-smipl-orange transition-colors duration-200">
            Contact
          </a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-slate-600">© 2022–2026 Swapna Meditech Industries Pvt. Ltd. · An ISO 9001:2015 Certified Company</p>
        <p className="text-xs text-slate-600 font-mono tracking-wider">TECHNOLOGY · INTEGRATED · DELIVERED</p>
      </div>
    </footer>
  );
};

export default Footer;
